import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/guide/guide.vue'
wx.createPage(MiniProgramPage)